'use client';

import { Stethoscope, Brain } from 'lucide-react';
import { PublicSection } from '../../../../components/public/PublicSection';
import { PROJECT_NAME } from '@shared/constants';
import { LandingPageCard } from '../components';

/**
 * @group Landing
 * @summary Service categories section displaying health and mental wellbeing services
 */
export function ServiceCategoriesSection() {
  const services = [
    {
      icon: Stethoscope,
      title: 'Health',
      description: 'Comprehensive healthcare consultations for a wide range of health concerns. Our fulltime employed, HPCSA-registered practitioners provide quality medical care, health advice, and support for your physical wellbeing.',
    },
    {
      icon: Brain,
      title: 'Mental Wellbeing',
      description: 'Affordable, confidential consultations for mental health support. Our fulltime employed, HPCSA-registered practitioners provide professional care for stress, anxiety, depression, and emotional wellbeing when you need it most.',
    },
  ];

  return (
    <PublicSection 
      heading="Find the Right Care Fast"
      headingColor="hsl(var(--hero-text))"
      subheadingColor="#B8B4B0"
      subheading={`Whatever health concern you're facing, ${PROJECT_NAME} connects you with qualified, fulltime employed HPCSA-registered practitioners quickly and efficiently. We provide comprehensive support for both your physical health and mental wellbeing.`}
      className="bg-hero-bg"
      indented
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {services.map((service, idx) => (
          <LandingPageCard
            key={idx}
            icon={service.icon}
            title={service.title}
            description={service.description}
          />
        ))}
      </div>
    </PublicSection>
  );
}
